export default __webpack_public_path__ + "static/ramanSharma4-bb7d46238faa9d197fb3047df4cce5ef.jpg";